"use client";

// anivive
import { Phone, RadioList, Text } from "@anivive/ui";

// private components
import { useWizard } from "../../context";
import Buttons from "../buttons";

// private
import styles from "./index.module.scss";

export default function ContactInfo({ review }: { review?: boolean }) {
  const { state, actions } = useWizard();

  const { email, method, phone } = state.data.contact ?? {};

  return (
    <>
      <div className={styles.container}>
        <div className="mb-4">
          <p className="text-style-body1-regular mb-2">What is your preferred contact method</p>
          <RadioList
            disabled={review}
            options={[
              { value: "EMAIL" as const, label: "Email" },
              { value: "PHONE" as const, label: "Phone" },
            ]}
            onChange={(value) =>
              actions.setData({
                contact: {
                  ...state.data.contact,
                  method: value,
                },
              })
            }
            required
            value={method ?? undefined}
          />
        </div>
        <div className="d-flex flex-column flex-md-row">
          <div className="mb-4 mb-md-0 me-md-3">
            <p className="text-style-body1-regular mb-1">Phone</p>
            <Phone
              className="w-100"
              disabled={review}
              onChange={(value) =>
                actions.setData({
                  contact: {
                    ...state.data.contact,
                    phone: value,
                  },
                })
              }
              required
              value={phone ?? ""}
            />
          </div>
          <div>
            <p className="text-style-body1-regular mb-1">Email</p>
            <Text className="w-100" disabled name="email" value={email ?? ""} />
          </div>
        </div>
      </div>

      {!review && <Buttons disabled={!(email && method && phone)} />}
    </>
  );
}
